export default {
  /**
   * 企业状态总览，包括项目状态统计、结构物统计及测点统计
   */
  getCorporationStat: {
    server: '/stats/corporation',
    method: 'get',
  },

  /**
   * 报警处理统计
   */
  getAlertStatusStat: {
    server: '/stats/alert-status',
    method: 'get',
  },

  /**
   * 监测设备健康统计
   * query: { projectId: number }
   */
  getDeviceHealthStat: {
    server: '/stats/measuring-device-health',
    method: 'get',
  },

  /**
   * 监测值统计
   * query: { projectId: number }
   */
  getMeasurementValueStat: {
    server: '/stats/measurement-value',
    method: 'get',
  },
};
